package com.milta.feature.optimizationquota.data.repository

import com.milta.core.network.PagedResult
import com.milta.feature.optimizationquota.data.remote.OptimizationQuotaApi
import com.milta.feature.optimizationquota.data.remote.dto.toDomain
import com.milta.feature.optimizationquota.data.remote.dto.toDto
import com.milta.feature.optimizationquota.domain.entity.AdminAccountOptimizationQuota
import com.milta.feature.optimizationquota.domain.entity.OptimizationHistoryEntry
import com.milta.feature.optimizationquota.domain.entity.OptimizationLimits
import com.milta.feature.optimizationquota.domain.entity.OptimizationQuota
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository
import com.milta.feature.route.data.remote.dto.toDomain

// No offline fallback: the counter changes server-side with every optimization, a cached value
// would show a button as available when it is not.
class OptimizationQuotaRepositoryImpl(private val api: OptimizationQuotaApi) : OptimizationQuotaRepository {
    override suspend fun getMyQuota(): Result<OptimizationQuota> = runCatching { api.getMyQuota().toDomain() }

    override suspend fun getMyHistory(page: Int, pageSize: Int): Result<PagedResult<OptimizationHistoryEntry>> =
        runCatching { api.getMyHistory(page, pageSize).toDomain { it.toDomain() } }

    override suspend fun getLimits(): Result<OptimizationLimits> = runCatching { api.getLimits().toDomain() }

    override suspend fun updateLimits(limits: OptimizationLimits): Result<OptimizationLimits> =
        runCatching { api.updateLimits(limits.toDto()).toDomain() }

    override suspend fun getAccountQuota(accountId: String): Result<AdminAccountOptimizationQuota> =
        runCatching { api.getAccountQuota(accountId).toDomain() }

    override suspend fun getAccountHistory(
        accountId: String,
        page: Int,
        pageSize: Int,
    ): Result<PagedResult<OptimizationHistoryEntry>> =
        runCatching { api.getAccountHistory(accountId, page, pageSize).toDomain { it.toDomain() } }

    override suspend fun replaceRemaining(accountId: String, remaining: Int): Result<OptimizationQuota> =
        runCatching { api.replaceRemaining(accountId, remaining).toDomain() }
}
